'use client';
import React, { useState } from 'react';
import styles from './trial-detail.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import Back from '@/components/back/back';
import Title from '@/components/title/title';
import TrialTab from '@/components/trial/trial-detail/trial-tab/trial-tab';
import SideTab from '@/components/trial/trial-detail/side-tab/side-tab';
import { TrialDetails } from '@scitrials-sst/core/Next/types';

export default function TrialDetail({
	trial,
	applied,
}: {
	trial: TrialDetails;
	applied: string[];
}) {
	const [tab, setTab] = useState<'overview' | 'details' | 'locations'>(
		'overview'
		// 'details'
		// 'locations'
	);

	const {
		curated,
		overallStatus,
		objectID,
		studyType,
		phases,
		investigatorFullName,
		overallOfficialsName,
		investigatorAffiliation,
		overallOfficialsAffiliation,
		startDateStructDate,
		startDateStructType,
		completionDateStructDate,
		completionDateStructType,
		studyFirstPostDateStructDate,
		lastUpdatePostDateStructDate,
	} = trial;

	return (
		<>
			<Back
				content={
					<>
						<FontAwesomeIcon icon={faChevronLeft} size='lg' /> back to trial
						list
					</>
				}
				cls={styles.back}
				to='/triallist'
			/>

			<Title text={trial?.briefTitle ?? ''} />

			<div className={styles.main}>
				<TrialTab tab={tab} setTab={setTab} trial={trial} applied={applied} />
				<SideTab
					setTab={setTab}
					trial={{
						curated,
						overallStatus,
						objectID,
						studyType,
						phases,
						investigatorFullName,
						overallOfficialsName,
						investigatorAffiliation,
						overallOfficialsAffiliation,
						startDateStructDate,
						startDateStructType,
						completionDateStructDate,
						completionDateStructType,
						studyFirstPostDateStructDate,
						lastUpdatePostDateStructDate,
					}}
				/>
			</div>
		</>
	);
}
